import { useMemo } from 'react';

import { useLiveAppInitializationQuery } from '@/hooks/api/queries/useLiveAppInitializationQuery';

export function getApplicationBasePathSegments() {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const [accountSlug, appSlug] = pathSegments;
  return { accountSlug, appSlug };
}

export function useApplicationHelpers() {
  const { data: initializationData } = useLiveAppInitializationQuery();

  const basePath = useMemo(() => {
    // If we're in custom domain mode, the base path is just "/"
    if (initializationData?.isCustomDomain) {
      return '/';
    }

    if (initializationData?.application.account && initializationData?.application) {
      return `/${initializationData.application.account.slug}/${initializationData.application.slug}`;
    }

    return '/';
  }, [initializationData]);

  return {
    accountSlug: initializationData?.application.account.slug || '',
    appSlug: initializationData?.application.slug || '',
    basePath
  };
}
